<app-standard-bottom-sheet [isOpen]="isOpen()"
                           [isFullScreen]="true"
                           (isOpenChange)="onSheetOpenChange($event)"
                           testId="discuss-demonstrate-drawer-new-issue">

  <app-section-header [title]="issue() ? 'Edit Item' : 'Add New Item'"
                      align="center"
                      testId="discuss-demonstrate-new-issue" />

  <form [formGroup]="issueForm"
        class="new-issue-form"
        data-testid="discuss-demonstrate-form-new-issue">

    <app-form-field label="Room"
                    inputId="room-select"
                    [required]="true"
                    [control]="issueForm.controls['areaIdentifier']"
                    [invalid]="isInvalid('areaIdentifier')"
                    [errorMessages]="{ required: 'Please select a room.' }"
                    testId="discuss-demonstrate-room">
      <app-select-field inputId="room-select"
                        formControlName="areaIdentifier"
                        [options]="areas()"
                        optionLabel="name"
                        optionValue="identifier"
                        [autoFocusFilter]="false"
                        placeholder="Select Room"
                        [filter]="true"
                        filterBy="name"
                        filterPlaceholder="Search rooms"
                        [invalid]="isInvalid('areaIdentifier')"
                        testId="discuss-demonstrate-select-room" />
      @if (displayUnassignedRoomMessage) {
        <app-severity-info [text]="(issue() ? 'Saved as Unassigned' : 'Save as Unassigned') + '. You can assign this room later in your Open Items list.'"
                           testId="unassigned-room-message" />
      }
    </app-form-field>

    <app-form-field label="Notes"
                    inputId="notes-textarea"
                    [required]="true"
                    [control]="issueForm.controls['text']"
                    [invalid]="isInvalid('text')"
                    [maxLength]="maxNoteLength"
                    [errorMessages]="{ required: 'Please add a note.' }"
                    testId="discuss-demonstrate-notes">
      <app-textarea inputId="notes-textarea"
                    formControlName="text"
                    placeholder="Describe the item..."
                    [maxLength]="maxNoteLength"
                    [showCount]="false"
                    [quickTapOptions]="quickTapNotes"
                    [invalid]="isInvalid('text')"
                    testId="discuss-demonstrate-textarea-notes" />
    </app-form-field>

    <app-form-field label="Photos"
                    [required]="photosRequired()"
                    [labelSuffix]="'(Max ' + maxPhotos + ')'"
                    [control]="issueForm.controls['images']"
                    [invalid]="isInvalid('images')"
                    [errorMessages]="{ required: 'At least one photo is required.' }"
                    testId="discuss-demonstrate-photos">
      <app-photo-capture inputId="discuss-demonstrate-new-issue"
                         [images]="allImages()"
                         [invalid]="isInvalid('images')"
                         [disabled]="imageCompressionPipelineService.isCompressingImages()"
                         [loading]="imageCompressionPipelineService.isLoadingImages()"
                         [optimizing]="imageCompressionPipelineService.isCompressingImages()"
                         [processingCount]="imageCompressionPipelineService.numberOfImagesBeingProcessed()"
                         (filesSelected)="onPhotosSelected($event)"
                         (imageClicked)="openImagesModal($event)"
                         testId="discuss-demonstrate-photo" />
    </app-form-field>

    <app-form-field label="Vendor"
                    inputId="vendor-select"
                    [optional]="true"
                    testId="discuss-demonstrate-vendor">
      <app-select-field inputId="vendor-select"
                        formControlName="externalVendorId"
                        [options]="vendors()"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Select Vendor"
                        [showClear]="true"
                        [filter]="true"
                        filterBy="name"
                        filterPlaceholder="Search vendors"
                        panelStyleClass="vendor-select-overlay"
                        testId="discuss-demonstrate-select-vendor">
        <ng-template #selectOptionItem
                     let-option
                     let-label="label">
          @if (option.id === selfAssignedVendorId) {
            <span class="bqa-pinned-select-option"
                  data-testid="discuss-demonstrate-assign-to-me-option">{{ assignToMeLabel }}</span>
          } @else {
            {{ label }}
          }
        </ng-template>
      </app-select-field>
    </app-form-field>
  </form>

  <app-vertical-button-group [buttons]="footerButtons"
                             testId="discuss-demonstrate-new-issue-footer" />
</app-standard-bottom-sheet>

<app-add-area-dialog [visible]="addRoomSheetOpen()"
                     (visibleChange)="onAddRoomSheetVisibleChange($event)"
                     [areasConfig]="areasConfig()"
                     [existingAreas]="areas()"
                     [zoneOptions]="zoneOptions()"
                     [isSaving]="savingRoom()"
                     [slideIn]="true"
                     (addArea)="onRoomSubmitted($event)"
                     data-testid="discuss-demonstrate-add-room" />